module.exports = __webpack_public_path__ + "static/media/document.e997b987.svg";